import { render, staticRenderFns } from "./detail-checklist.vue?vue&type=template&id=6aef89f8&"
import script from "./detail-checklist.vue?vue&type=script&lang=js&"
export * from "./detail-checklist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports